module.exports = __webpack_public_path__ + "img/ic_medium_interview-active.f6e91f1d.svg";